import {BoxProps, useMediaQuery} from '@chakra-ui/react';
import classNames from 'classnames';
import React, {memo, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {UiBox, UiButton} from '~/components/elements';
import {Col} from '~/components/elements/grid/Col';
import {QUERY_MOBILE} from '~/constants';
import {AppDispatch} from '~/redux/root-store';

interface Props extends BoxProps {
  children: React.ReactNode;
  containerClasses?: string;
}

export const UiApplicationsFormsLayout = memo(function UiApplicationsFormsLayout({
  containerClasses,
  children,
  ...rest
}: Props) {
  const [isDesktop] = useMediaQuery(`(min-width: ${QUERY_MOBILE})`);
  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Col position="relative" py={5} {...rest}>
      <Col flex={1}>
        <Col
          id="qns-layout"
          className={classNames(`animate__animated animate__fadeInLeft`, containerClasses)}
          flex={1}
          // flexGrow={1}'
        >
          {children}
        </Col>
      </Col>
    </Col>
  );
});
